export default "__VITE_ASSET__534894fb__"